
import InputCheck from './common/InputCheck.vue'
import ConfirmDlg from '@/components/common/ConfirmDlg.vue'

import { useApi } from '@/lib/api'
import { formatDate } from '@/lib/filters'
import { defineComponent, ref, getCurrentInstance } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { GlobalState } from '@/lib/types'
import { useAppViewedList } from '@/lib/common'

export default defineComponent({
  components: { InputCheck, ConfirmDlg },
  setup() {
    const { setRecord } = useAppViewedList()
    const _api = useApi()
    const _store = useStore<GlobalState>()
    const _route = useRoute()
    const _router = useRouter()
    const data = ref({ user: { id: null, active: null }, certList: [], clientList: [], reportList: [] })
    const dlgDel = ref()
    const _inst = getCurrentInstance()

    const getData = async () => {
      const res = await _api.get<any>('adminUser?id=' + _route.params.id)
      data.value = res.data
      setRecord('userList' + _route.params.id)
    }

    const postData = async () => {
      const url = _store.state.user.superAdmin === true ? `adminUserWrite` : 'adminUserWriteActive'
      const res = await _api.post<any>(url, data.value.user)
      _inst?.appContext.config.globalProperties.emitter.emit('showToaster', { theme: 'green', text: 'Podatki shranjeni' })
      data.value = res.data
    }

    const unlock = async () => {
      const res = await _api.get<any>(`adminUserWriteBadLogin?id=${data.value.user.id}`)
      _inst?.appContext.config.globalProperties.emitter.emit('showToaster', { theme: 'green', text: 'Uporabnik odklenjen.' })
      data.value = res.data
    }

    const delUser = async (c: boolean) => {
      if (c === true) {
        const res = await _api.delete<any>(`adminUserDelete?id=${data.value.user.id}`)
        if (res.status === 200) {
          _inst?.appContext.config.globalProperties.emitter.emit('showToaster', { theme: 'green', text: 'Uporabnik izbrisan.' })
          _router.push({ name: 'adminUserList' })
        }
      }
    }

    getData()

    return { data, formatDate, dlgDel, postData, unlock, delUser }
  }
})
